// skinconcern
const Listskinconcern = () => import('@/views/setting/skin-concern')
const Formskinconcern = () => import('@/views/setting/skin-concern/form')

export default {
    path: 'skin-concern',
    redirect: '/skin-concern',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'skin-concern',
            component: Listskinconcern,
            meta: {
                link: 'skin-concern',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Skin Concern', active: true },
                ],
                pageTitle: 'Skin Concern'
            }
        },
        {
            path: 'add',
            name: 'addskinconcern',
            component: Formskinconcern,
            meta: {
                link: 'skin-concern',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Skin Concern', url: '/skin-concern' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Skin Concern'
            }
        },
        {
            path: 'edit/:id',
            name: 'editskinconcern',
            component: Formskinconcern,
            meta: {
                link: 'skin-concern',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Skin Concern', url: '/skin-concern' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Skin Concern'
            }
        },
    ]
}